import React from "react";
import classnames from "classnames";

export default function Tab({
  bordered,
  isActive,
  onClick,
  children,
}: Props) {
  return (
    <div
      className={classnames(
        'inner-tab',
        bordered && 'inner-tab--with-border',
        isActive && 'inner-tab--active',
      )}
      onClick={onClick}
      onKeyUp={onClick}
      role="tab"
      tabIndex={-1}
    >
      {children}
    </div>
  );
}

export interface Props {
  bordered?: boolean,
  children: React.ReactNode,
  isActive: boolean,
  onClick: (_?: any) => void,
}

Tab.defaultProps = {
  bordered: false,
};
